import React, { useState } from "react";
import theme from "../../styles/theme.json";

const Especialidade = ({ servicos }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Função para manipular o clique nas opções
  const handleOptionClick = (id, titulo) => {
    setSelectedOption(titulo); // Atualiza o título da especialidade selecionada
    setIsDropdownOpen(false);  // Fecha o dropdown
    // Você pode usar o id se precisar fazer algo com ele, como salvar em um estado ou enviar para a API
    console.log("ID selecionado:", id);
  };

  return (
    <div style={{ position: "relative" }}>
      <h4 style={{ fontWeight: "700", marginBottom: "10px", color: theme.colors.dark }}>
        Selecione uma especialidade
      </h4>

      {/* Dropdown Trigger */}
      <div
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        style={{
          backgroundColor: theme.colors.light,
          color: theme.colors.dark,
          border: `1px solid ${theme.colors.muted}`,
          borderRadius: "8px",
          padding: "10px 15px",
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <span>{selectedOption || "Escolha uma especialidade"}</span>
        <span style={{ transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0)", transition: "0.3s" }}>
          ▼
        </span>
      </div>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            width: "100%",
            backgroundColor: theme.colors.light,
            border: `1px solid ${theme.colors.muted}`,
            borderRadius: "8px",
            marginTop: "5px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 10,
          }}
        >
          {servicos.map((especialidade) => (
            <div
              key={especialidade.id}
              onClick={() => handleOptionClick(especialidade.id, especialidade.titulo)}
              style={{
                padding: "10px 15px",
                cursor: "pointer",
                color: theme.colors.dark,
                backgroundColor: selectedOption === especialidade.titulo ? theme.colors.primary : theme.colors.light,
                color: selectedOption === especialidade.titulo ? theme.colors.light : theme.colors.dark,
                borderRadius: "8px",
                margin: "2px 0",
                transition: "background-color 0.3s",
              }}
            >
              {especialidade.titulo}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Especialidade;
